module.exports = __webpack_public_path__ + "img/hovered-layer4.fa7131e9.png";